import React from 'react';
import { Badge, BadgeProps } from '@doveit/bricks';
import { Task } from '../../../providers/api/dtos';
import { taskPriorityColors, taskPriorityIcons } from '../../constants';

export interface TaskPriorityBadgeProps extends React.AriaAttributes {
  task: Task,
  size?: BadgeProps['size'],
  showIcon?: boolean,
}

const TaskPriorityBadge: React.FC<TaskPriorityBadgeProps> = ({
  task,
  size,
  showIcon,
  ...rest
}) => {
  if (!task.code) {
    return null;
  }

  return (
    <Badge
      aria-label="Badge priority attività"
      {...rest}
      label={task.code}
      color={taskPriorityColors[task.priority]}
      icon={showIcon ? taskPriorityIcons[task.priority] : undefined}
      size={size}
    />
  );
};

export default TaskPriorityBadge;
